<div class="renameDashlet">
  <title class="renameDashlet__type">{{ dashletType }}:</title>

  <input
    data-test="renameDashletInput"
    class="renameDashlet__input"
    type="text"
    [(ngModel)]="dashletName"
    (ngModelChange)="onNameChange($event)"
    (change)="save()"
    [placeholder]="'rename_dashlet_placeholder' | ppTranslate"
    (keydown)="$event.stopPropagation()"
    (mousedown)="$event.stopPropagation()"
    (blur)="save()"
  />
</div>
